import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioCmp2 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_CMP2: TIdToPageConfigMap = {
  [PageIdStylioCmp2.AGE_CMP2]: {
    id: PageIdStylioCmp2.AGE_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioCmp2.CURRENT_WARDROBE_CMP2]: {
    id: PageIdStylioCmp2.CURRENT_WARDROBE_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.URGE_1_CMP2]: {
    id: PageIdStylioCmp2.URGE_1_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.WARDROBE_GOAL_CMP2]: {
    id: PageIdStylioCmp2.WARDROBE_GOAL_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.HAIR_COLOR_CMP2]: {
    id: PageIdStylioCmp2.HAIR_COLOR_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.EYES_COLOR_CMP2]: {
    id: PageIdStylioCmp2.EYES_COLOR_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.SKIN_COLOR_CMP2]: {
    id: PageIdStylioCmp2.SKIN_COLOR_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.JEWELRY_CMP2]: {
    id: PageIdStylioCmp2.JEWELRY_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.COLOR_PALETTE_CMP2]: {
    id: PageIdStylioCmp2.COLOR_PALETTE_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.COLOR_HARMONY_CMP2]: {
    id: PageIdStylioCmp2.COLOR_HARMONY_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.URGE_6_CMP2]: {
    id: PageIdStylioCmp2.URGE_6_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.BODY_SHAPE_CMP2]: {
    id: PageIdStylioCmp2.BODY_SHAPE_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.TALL_CMP2]: {
    id: PageIdStylioCmp2.TALL_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.WEIGHT_CMP2]: {
    id: PageIdStylioCmp2.WEIGHT_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.URGE_5_CMP2]: {
    id: PageIdStylioCmp2.URGE_5_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.FEEL_ABOUT_CMP2]: {
    id: PageIdStylioCmp2.FEEL_ABOUT_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.URGE_2_CMP2]: {
    id: PageIdStylioCmp2.URGE_2_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.STYLE_COMPLIMENTS_CMP2]: {
    id: PageIdStylioCmp2.STYLE_COMPLIMENTS_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.PERCENTAGE_CMP2]: {
    id: PageIdStylioCmp2.PERCENTAGE_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.SHOPPING_CMP2]: {
    id: PageIdStylioCmp2.SHOPPING_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.STYLE_MOST_MATTERS_CMP2]: {
    id: PageIdStylioCmp2.STYLE_MOST_MATTERS_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_11_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_11_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_12_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_12_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_13_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_13_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_14_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_14_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_15_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_15_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_16_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_16_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_17_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_17_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_18_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_18_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIKE_OR_DISLIKE_19_CMP2]: {
    id: PageIdStylioCmp2.LIKE_OR_DISLIKE_19_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.STYLES_FEEL_LIKE_YOU_CMP2]: {
    id: PageIdStylioCmp2.STYLES_FEEL_LIKE_YOU_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.URGE_8_CMP2]: {
    id: PageIdStylioCmp2.URGE_8_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.BRAND_CMP2]: {
    id: PageIdStylioCmp2.BRAND_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.AVOID_COLORS_CMP2]: {
    id: PageIdStylioCmp2.AVOID_COLORS_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.AVOIDED_COLORS_CMP2]: {
    id: PageIdStylioCmp2.AVOIDED_COLORS_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.URGE_7_CMP2]: {
    id: PageIdStylioCmp2.URGE_7_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.FIND_NEW_CLOTHES_CMP2]: {
    id: PageIdStylioCmp2.FIND_NEW_CLOTHES_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.JACKET_COAT_BUDGET_CMP2]: {
    id: PageIdStylioCmp2.JACKET_COAT_BUDGET_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.TOP_BUDGET_CMP2]: {
    id: PageIdStylioCmp2.TOP_BUDGET_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.BOTTOM_BUDGET_CMP2]: {
    id: PageIdStylioCmp2.BOTTOM_BUDGET_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.SHOES_BUDGET_CMP2]: {
    id: PageIdStylioCmp2.SHOES_BUDGET_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.YOUR_LOCATION_CMP2]: {
    id: PageIdStylioCmp2.YOUR_LOCATION_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.WARDROBE_REFRESH_CMP2]: {
    id: PageIdStylioCmp2.WARDROBE_REFRESH_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.SEASON_CHANGE_CHALLENGES_CMP2]: {
    id: PageIdStylioCmp2.SEASON_CHANGE_CHALLENGES_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.LIFESTYLE_MATCH_CMP2]: {
    id: PageIdStylioCmp2.LIFESTYLE_MATCH_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.WEEKEND_ACTIVITIES_CMP2]: {
    id: PageIdStylioCmp2.WEEKEND_ACTIVITIES_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.OUTFIT_OCCASIONS_CMP2]: {
    id: PageIdStylioCmp2.OUTFIT_OCCASIONS_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.QUIZ_SUMMARY_CMP2]: {
    id: PageIdStylioCmp2.QUIZ_SUMMARY_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.EXCITED_CAPSULE_PLAN_CMP2]: {
    id: PageIdStylioCmp2.EXCITED_CAPSULE_PLAN_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.URGE_3_CMP2]: {
    id: PageIdStylioCmp2.URGE_3_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.URGE_4_CMP2]: {
    id: PageIdStylioCmp2.URGE_4_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.BODY_SHAPE_CONFIDENCE_CMP2]: {
    id: PageIdStylioCmp2.BODY_SHAPE_CONFIDENCE_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.OUTFIT_ON_OTHERS_CMP2]: {
    id: PageIdStylioCmp2.OUTFIT_ON_OTHERS_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.DRAW_LESS_ATTENTION_CMP2]: {
    id: PageIdStylioCmp2.DRAW_LESS_ATTENTION_CMP2,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioCmp2.PREPARE_FLOW_CMP2]: {
    id: PageIdStylioCmp2.PREPARE_FLOW_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.EMAIL_CMP2]: {
    id: PageIdStylioCmp2.EMAIL_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.EMAIL_CONSENT_CMP2]: {
    id: PageIdStylioCmp2.EMAIL_CONSENT_CMP2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioCmp2.SUBSCRIPTIONS_CMP2]: {
    id: PageIdStylioCmp2.SUBSCRIPTIONS_CMP2,
  },
  [PageIdStylioCmp2.CANCEL_OFFER_CMP2]: {
    id: PageIdStylioCmp2.CANCEL_OFFER_CMP2,
  },
  [PageIdStylioCmp2.SUB_UPSELL_CMP2]: {
    id: PageIdStylioCmp2.SUB_UPSELL_CMP2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCmp2.UPSELL_CMP2]: {
    id: PageIdStylioCmp2.UPSELL_CMP2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioCmp2.DOWNLOAD_CMP2]: {
    id: PageIdStylioCmp2.DOWNLOAD_CMP2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
